module.exports = __webpack_public_path__ + "static/media/monoporzioni_2.ad9c836f.jpg";